module.exports = __webpack_public_path__ + "media/images/bnr-insta-stories-35783a8cecabfd77cd7d918597838509.png";